export default __webpack_public_path__ + "static/media/pink-leaf.c44737a7.png";